import type { HeaderProcessor } from './HeaderProcessor';

export const id: HeaderProcessor = (headers) => headers;
